import { AlertTriangle } from "lucide-react";
import { cn } from "~/lib/utils";

interface RiskPanelProps {
  message: string;
  detail?: string;
  severity?: "warning" | "danger";
  className?: string;
}

export function RiskPanel({ message, detail, severity = "warning", className }: RiskPanelProps) {
  const isDanger = severity === "danger";
  return (
    <div
      className={cn(
        "flex items-start gap-2.5 rounded-md border px-3 py-2.5",
        isDanger
          ? "border-destructive/30 bg-destructive/5 text-destructive"
          : "border-amber-300/30 bg-amber-50/80 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/20",
        className,
      )}
    >
      <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
      <div className="space-y-0.5 min-w-0">
        <p className="text-sm font-medium">{message}</p>
        {detail && <p className="text-xs opacity-80">{detail}</p>}
      </div>
    </div>
  );
}
